(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero-polaroid"] && !Shopify.designMode) return;
  try {
    
class PolaroidStack extends HTMLElement {
  connectedCallback() {
    this._cards = Array.from(this.querySelectorAll('[data-card]'));
    this._animating = false;
    this._applyPositions();

    const next = this.querySelector('[data-next]');
    const prev = this.querySelector('[data-prev]');
    if (next) next.addEventListener('click', () => this._sendToBack());
    if (prev) prev.addEventListener('click', () => this._bringToFront());
  }

  /* Set data-position on each card based on its current array index */
  _applyPositions() {
    this._cards.forEach((card, i) => {
      card.dataset.position = Math.min(i, 5);
    });
  }

  /* Next — top card flies off to the right, then gets placed at the back */
  _sendToBack() {
    if (this._animating || this._cards.length < 2) return;
    this._animating = true;

    const topCard = this._cards[0];
    let done = false;

    const finish = () => {
      if (done) return;
      done = true;

      topCard.style.transition = 'none';
      topCard.classList.remove('is-exiting');
      this._cards.push(this._cards.shift()); /* rotate array */
      this._applyPositions();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          topCard.style.transition = '';
          this._animating = false;
        });
      });
    };

    topCard.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 550); /* fallback */
    topCard.classList.add('is-exiting');
  }

  /* Prev — last card snaps to off-right, then flies into the front */
  _bringToFront() {
    if (this._animating || this._cards.length < 2) return;
    this._animating = true;

    const backCard = this._cards[this._cards.length - 1];

    /* Snap to the off-screen starting position (no transition) */
    backCard.classList.add('is-entering');
    /* Promote to front of the array */
    this._cards.unshift(this._cards.pop());
    this._applyPositions();

    /* Force reflow so browser registers the is-entering snapshot */
    backCard.offsetHeight; // eslint-disable-line no-unused-expressions

    /* Drop is-entering — transition kicks in and animates to position 0 */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        backCard.classList.remove('is-entering');
        setTimeout(() => { this._animating = false; }, 550);
      });
    });
  }
}

if (!customElements.get('polaroid-stack')) {
  customElements.define('polaroid-stack', PolaroidStack);
}

  } catch(e) { console.error(e); }
})();
})();
